export default {"src":"/hedera/_next/static/media/hedera_light.c428e425.svg","height":10,"width":10};